// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__xsWzP","imageUploader":"EGiftCard_imageUploader__xYF3P"};